import script from "./MapDetailBackButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapDetailBackButton.vue?vue&type=script&lang=ts&setup=true"

import "./MapDetailBackButton.vue?vue&type=style&index=0&id=94856b94&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94856b94"]])

export default __exports__